import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {NgSelectModule} from '@ng-select/ng-select';

import {SharedModule} from '@shared/shared.module';
import {MachineRoutingModule} from '@components/administration/machine/machine-routing.module';
import {MachineComponent} from '@components/administration/machine/machine.component';
import {MachineActionComponent} from '@components/administration/machine/machine-action/machine-action.component';
import {MachineEditComponent} from '@components/administration/machine/modals/machine-edit/machine-edit.component';
import {
  ImportSettingsComponent
} from '@components/administration/machine/modals/import-settings/import-settings.component';
import {GatewayComponent} from '@components/administration/machine/modals/gateway/gateway.component';
import {
  MachineCloningInfoComponent
} from '@components/administration/machine/modals/machine-cloning-info/machine-cloning-info.component';
import {
  MachineConfigurationComponent
} from '@components/administration/machine/machine-configuration/machine-configuration.component';
import {
  DataConfigurationComponent
} from '@components/administration/machine/machine-configuration/configuration/data-configuration/data-configuration.component';
import {
  StatusIndicatorComponent
} from '@components/administration/machine/machine-configuration/configuration/status-indicator/status-indicator.component';
import {
  TrafficLightComponent
} from '@components/administration/machine/machine-configuration/configuration/traffic-light/traffic-light.component';
import {
  TriggerConfigurationComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-configuration/trigger-configuration.component';
import {
  ApiConfigurationComponent
} from '@components/administration/machine/machine-configuration/trigger/api-configuration/api-configuration.component';
import {
  TrafficLightElementComponent
} from '@components/administration/machine/machine-configuration/configuration/traffic-light/traffic-light-element/traffic-light-element.component';
import {
  SignalEditModalComponent
} from '@components/administration/machine/machine-configuration/configuration/data-configuration/data-configuration-edit/signal-edit-modal/signal-edit-modal.component';
import {
  CalculatedSignalEditModalComponent
} from '@components/administration/machine/machine-configuration/configuration/data-configuration/data-configuration-edit/calculated-signal-edit-modal/calculated-signal-edit-modal.component';
import {
  TriggerQueryActionComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-query/trigger-query-action/trigger-query-action.component';
import {
  TriggerQueryEditComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-query/modals/trigger-query-edit/trigger-query-edit.component';
import {
  EmailActionTypeComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-query/action-type/email-action-type/email-action-type.component';
import {
  TriggerQueryComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-query/trigger-query.component';
import {
  NotificationActionTypeComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-query/action-type/notification-action-type/notification-action-type.component';
import {
  PubSubActionTypeComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-query/action-type/pub-sub-action-type/pub-sub-action-type.component';
import {
  ApiConfigurationEditComponent
} from '@components/administration/machine/machine-configuration/trigger/api-configuration/modals/api-configuration-edit/api-configuration-edit.component';
import {
  ApiConfigurationActionComponent
} from '@components/administration/machine/machine-configuration/trigger/api-configuration/api-configuration-action/api-configuration-action/api-configuration-action.component';
import {
  TriggerConfigurationActionComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-configuration/trigger-configuration-action/trigger-configuration-action.component';
import {
  TriggerConfigurationEditComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-configuration/modals/trigger-configuration-edit/trigger-configuration-edit.component';
import {
  TimeBasedComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-configuration/trigger-type/time-based/time-based.component';
import {
  ValueBasedComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-configuration/trigger-type/value-based/value-based.component';
import {
  OpcOfflineComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-configuration/trigger-type/opc-offline/opc-offline.component';
import {
  OpcNoDataComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-configuration/trigger-type/opc-no-data/opc-no-data.component';
import {
  TriggerExpressionTableComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-configuration/trigger-type/common/trigger-expression-table/trigger-expression-table.component';
import {
  TriggerSignalExpressionTableComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-configuration/trigger-type/common/trigger-expression-table/trigger-signal-expression-table/trigger-signal-expression-table.component';
import {
  TriggerTimeExpressionTableComponent
} from '@components/administration/machine/machine-configuration/trigger/trigger-configuration/trigger-type/common/trigger-expression-table/trigger-time-expression-table/trigger-time-expression-table.component';
import {
  MachineLocationComponent
} from '@components/administration/machine/modals/machine-edit/machine-location/machine-location.component';
import {provideHttpClient, withInterceptorsFromDi, withJsonpSupport} from '@angular/common/http';
import {GoogleMapsModule} from '@angular/google-maps';
import {
  StatusEventSignalConfigurationComponent
} from '@components/administration/machine/machine-configuration/configuration/data-configuration/data-configuration-edit/status-event-signal-configuration/status-event-signal-configuration.component';
import {
  StatusEventSignalConfigurationPreviewComponent
} from '@components/administration/machine/machine-configuration/configuration/data-configuration/data-configuration-edit/status-event-signal-configuration/status-event-signal-configuration-preview/status-event-signal-configuration-preview.component';
import {
  MachineTagComponent
} from '@components/administration/machine/modals/machine-edit/machine-tag/machine-tag.component';
import {
  MachineDefaultGatewayComponent
} from '@components/administration/machine/modals/machine-edit/machine-default-gateway/machine-default-gateway.component';
import {
  ApplyToMachinesOfSameTagWarningComponent
} from '@components/administration/machine/machine-configuration/configuration/data-configuration/data-configuration-edit/apply-to-machines-of-same-tag-warning/apply-to-machines-of-same-tag-warning.component';
import {
  MachineDeleteComponent
} from '@components/administration/machine/modals/machine-delete/machine-delete.component';
import {MetadataModule} from '@components/administration/metadata/metadata.module';

@NgModule({
  declarations: [
    MachineComponent,
    MachineActionComponent,
    MachineEditComponent,
    ImportSettingsComponent,
    GatewayComponent,
    MachineCloningInfoComponent,
    GatewayComponent,
    ImportSettingsComponent,
    MachineConfigurationComponent,
    DataConfigurationComponent,
    StatusIndicatorComponent,
    TrafficLightComponent,
    TriggerQueryComponent,
    TriggerConfigurationComponent,
    ApiConfigurationComponent,
    TrafficLightElementComponent,
    MachineComponent,
    TrafficLightElementComponent,
    SignalEditModalComponent,
    CalculatedSignalEditModalComponent,
    TriggerQueryActionComponent,
    TriggerQueryEditComponent,
    EmailActionTypeComponent,
    NotificationActionTypeComponent,
    PubSubActionTypeComponent,
    ApiConfigurationEditComponent,
    ApiConfigurationActionComponent,
    TriggerConfigurationActionComponent,
    TriggerConfigurationEditComponent,
    TimeBasedComponent,
    ValueBasedComponent,
    OpcOfflineComponent,
    OpcNoDataComponent,
    TriggerExpressionTableComponent,
    TriggerSignalExpressionTableComponent,
    TriggerTimeExpressionTableComponent,
    MachineLocationComponent,
    StatusEventSignalConfigurationComponent,
    StatusEventSignalConfigurationPreviewComponent,
    MachineTagComponent,
    MachineDefaultGatewayComponent,
    ApplyToMachinesOfSameTagWarningComponent,
    MachineDeleteComponent
  ],
  exports: [
    MachineComponent,
    ValueBasedComponent,
  ],
  imports: [
    CommonModule,
    MachineRoutingModule,
    TranslateModule,
    NgbModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    ReactiveFormsModule,
    SharedModule,
    GoogleMapsModule,
    MetadataModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())
  ]
})
export class MachineModule {
}
